import ProductionPeriod from '@/types/ProductionPeriod';
import ImageInfo from '@/types/ImageInfo';
import CollectedItem from '@/types/CollectedItem';
import Amount from '@/types/Amount';

export default class CollectedProduct {
    public productId: string;
    public iconImage: ImageInfo;
    public productName: Map<string, string>;
    public productionPeriods: ProductionPeriod[];
	public collectedItems: CollectedItem[];
	public totalPurchaseAmount: Amount;
	public totalEstimatedValueAmount: Amount;
}
